var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 509,
    viewBox: "0 0 668 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.364 251.521H203.095C201.42 247.333 199.074 237.113 203.095 229.742C207.116 222.371 219.848 218.853 225.712 218.015C222.082 215.502 215.272 201.509 225.712 189.404C234.381 179.352 252.796 182.554 260.893 185.347C259.497 180.6 262.023 168.965 272.075 164.275C284.64 158.411 292.444 167.198 297.749 171.106C299.983 161.334 312.157 143.129 342.982 148.49C367.567 152.766 375.371 175.295 372.3 185.347C374.534 179.204 401.911 171.106 425.91 185.347C454.767 202.47 457.182 235.606 449.364 251.521Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.004 277.354H379.297C372.876 272.887 361.874 260.937 369.246 248.874C376.617 236.811 399.68 236.588 410.29 237.985C417.829 230.725 427.546 217.549 446.309 219.56C465.073 221.57 474.789 239.66 472.277 248.874C476.186 247.478 485.846 247.031 493.218 256.413C500.589 265.795 490.146 274.283 484.004 277.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.249 355.415L166.32 299.219L272.402 402.447L271.249 355.415Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.239 329.256L166.32 299.219L271.249 355.415L301.239 329.256Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.777 402.009L240.195 381.763L253.286 369.257C254.471 368.125 256.42 368.498 257.103 369.989L271.777 402.009Z",
    fill: "#D6E4FF",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.128 404.132L165.695 298.781L255.269 367.571L216.128 404.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.43 406.355C277.105 417.524 288.329 439.694 319.825 439.024C351.321 438.354 360.311 425.342 360.87 418.92C362.545 412.777 362.21 399.152 347.467 393.791C329.039 387.089 324.934 406.982 327.364 413.057C329.039 417.245 331.552 429.809 365.896 444.887C393.371 456.949 420.901 442.095 431.232 433.16",
    stroke: "black",
    strokeWidth: 2.38571,
    strokeDasharray: "7.16 7.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/Picture.d286a671797f1244d0ba26eeaa04cf6f.svg";
export { ForwardRef as ReactComponent };